import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import FundraisingEditAmbassadorForm from 'src/components/Forms/Fundraising/FundraisingEditAmbassadorForm';

const EditAmbassadorModal = () => (
  <ModalBase
    name={MODALS.editAmbassador}
    size={MODALS_SIZE.small}
    form={FORM.fundraising}>
    <FundraisingEditAmbassadorForm />
  </ModalBase>
);

export default EditAmbassadorModal;
